// extracted by mini-css-extract-plugin
export default {"grey":"StuPicker_grey__8poD4","blue":"StuPicker_blue__U26v0"};